app.factory('visitService', ['$q', '$rootScope', 'baseService', 'objectHelper', 'config',
    function($q, $rootScope, baseService, objectHelper, config) {

	    function VisitService() {
	
	    	this.getDataPage = function(criteria) {
	            var d = $q.defer();
	
	            baseService.post(config.API_URL + '/visits/dataPage', objectHelper.convertDatesToTimes(criteria)).then(
	                function(successResponse) {
	                    var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
	                    dataPage.data = objectHelper.translateArray(dataPage.data, VisitVO);
	                    dataPage.data = objectHelper.convertTimesToDates(dataPage.data);
	
	                    d.resolve(dataPage);
	                },
	                function(errorResponse) {
	                    d.reject(errorResponse);
	                }
	            );
	
	            return d.promise;
	        };
	        
	        this.getById = function(id) {
	            var d = $q.defer();
	
	            baseService.get(config.API_URL + '/visits/' + id).then(
	                function(successResponse) {
	                    var data = objectHelper.translateObject(successResponse, VisitVO);
	                    data = objectHelper.convertTimesToDates(data);

	                    d.resolve(data);
	                },
	                function(errorResponse) {
	                    d.reject(errorResponse);
	                }
	            );
	
	            return d.promise;
	        };

			this.begin = function(id) {
				var d = $q.defer();

				baseService.post(config.API_URL + '/visits/' + id + '/begin').then(
					function(successResponse) {
						var data = objectHelper.translateObject(successResponse, VisitVO);
						data = objectHelper.convertTimesToDates(data);

						d.resolve(data);
					},
					function(errorResponse) {
						d.reject(errorResponse);
					}
				);

				return d.promise;
			};

			this.save = function (visit) {
				return baseService.post(config.API_URL + '/visits', visit).then(
					function (successResponse) {
						var data = objectHelper.translateObject(successResponse, VisitVO);
						return data;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.update = function (visit) {
				return baseService.post(config.API_URL + '/visits/' + visit.id, visit).then(
					function (successResponse) {
						var data = objectHelper.translateObject(successResponse, VisitVO);
						return data;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.delete = function (visit) {
				return baseService.delete(config.API_URL + '/visits/' + visit.id).then(
					function(successResponse) {
						return successResponse;
					},
					function(errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.cancel = function (visit, status) {
				return baseService.post(config.API_URL + '/visits/' + visit.id + '/cancel').then(
					function(successResponse) {
						return successResponse;
					},
					function(errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.getStreamingConnectionDetails = function (streamingSessionId) {
				return baseService.get(config.API_URL + '/visits/streamingConnectionDetails/' + streamingSessionId).then(
					function(successResponse) {
						return successResponse;
					},
					function(errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.getLastVisitForPatient = function (patientId, doctorId) {
				return baseService.get(config.API_URL + '/visits/lastVisitForPatient/' + patientId + '/withDoctor/' + doctorId).then(
					function(successResponse) {
						var data = objectHelper.translateObject(successResponse, VisitVO);
						return data;
					},
					function(errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.suspend = function (visit) {
				return baseService.post(config.API_URL + '/visits/' + visit.id + '/suspend', visit).then(
					function (successResponse) {
						var data = objectHelper.translateObject(successResponse, VisitVO);
						return data;
					},
					function (errorResponse) {

					}
				);
			};

			this.complete = function (visit) {
				return baseService.post(config.API_URL + '/visits/' + visit.id + '/complete', visit).then(
					function(successResponse) {
						return successResponse;
					},
					function(errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.getZM = function(visitId) {
				return baseService.get(config.API_URL + '/zm/' + visitId).then(
					function(successResponse) {
						var data = objectHelper.translateObject(successResponse, ZMVO);
						data = objectHelper.convertTimesToDates(data);
						return data;
					},
					function(errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.sendZM = function(visitId) {
				$rootScope.ignoreError.push(config.API_URL + '/zm/' + visitId);
				return baseService.post(config.API_URL + '/zm/' + visitId, baseService.createSupressErrorsConfig()).then(
					function(successResponse) {
						return successResponse;
					},
					function(errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

	    }
	
	    return new VisitService();
	}
]);
